
import Vue from 'vue';
import axios from "axios";

export default Vue.extend({
  name: 'Qiwi',
  data() {
    return {
      countryID: "ru",
      message: "",
      isSendEnabled: false,
      isQiwiSendDisabled: false,
      isSendQiwiError: false,
      isTochkaSendDisabled: false,
      isSolarSendDisabled: false,
      isSendSolarError: false,
      isSendTochkaError: false,
      isSparkasseSendDisabled: false,
      isSendSparkasseError: false,
      isRevolutPolandSendDisabled: false,
      isSendRevolutPolandError: false,
      isLoadPaymentsRuDisabled: false,
      isLoadPaymentsRuError: false,
      isLoadPaymentsDeDisabled: false,
      isLoadPaymentsDeError: false,
      isInvoicesCreateTasksRuDisabled: false,
      isInvoicesCreateTasksRuError: false,
      isInvoicesCreateTasksDeDisabled: false,
      isInvoicesCreateTasksDeError: false,
      isPayoutStatusUpdateRuDisabled: false,
      isPayoutStatusUpdateRuError: false,
      isPayoutStatusUpdateDeDisabled: false,
      isPayoutStatusUpdateDeError: false,
      isInvoicesMassCreateRuDisabled: false,
      isInvoicesMassCreateRuError: false,
      isInvoicesMassCreateDeDisabled: false,
      isInvoicesMassCreateDeError: false,
      isInvoicesMassSendDeDisabled: false,
      isInvoicesMassSendDeError: false,
      isInvoicesMassCreateAtDisabled: false,
      isInvoicesMassCreateAtError: false,
      isInvoicesMassSendAtDisabled: false,
      isInvoicesMassSendAtError: false,
      isInvoicesMassCreatePlDisabled: false,
      isInvoicesMassCreatePlError: false,
      isInvoicesMassSendPlDisabled: false,
      isInvoicesCallTranscribeDisabled: false,
      isInvoicesMassSendPlError: false,
      isCallTranscribeError: false,
      balanceQiwi: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceTochkaServices: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceTochkaExpendables: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceIE: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceExpendables: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceSolarStaff: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceRevolutEU: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      balanceRevolutPL: {
        amount: 0,
        debt_expendables: 0,
        debt_services: 0,
        debt_in_queue: 0,
        is_dangerous: false,
        show_details: false,
      },
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
    }
  },
  methods: {

    getBalance() {

      axios.get(`/qiwi-payout-api-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceQiwi = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/tochka-services-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceTochkaServices = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/tochka-expendables-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceTochkaExpendables = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/ie-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceIE = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/expendables-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceExpendables = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/solarstaff-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceSolarStaff = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

      axios.get(`/revolut-eu-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceRevolutEU = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

 axios.get(`/revolut-pl-balance`)
          .then((res) => {
            console.log(res.data);

            let balance = res.data;
            this.balanceRevolutPL = balance;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });

    },

    sendQiwi() {

      this.message = '';
      this.isQiwiSendDisabled = true;
      this.isSendQiwiError = false;

      axios.get(`/payout_create_qiwicard?country_id=ru`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isSendQiwiError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isQiwiSendDisabled = false;
          });
    },

    sendSolar() {

      this.message = '';
      this.isSolarSendDisabled = true;
      this.isSendSolarError = false;

      axios.get(`/payout_solar_staff_create`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isSendSolarError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isSolarSendDisabled = false;
          });
    },

    sendTochka() {

      this.message = '';
      this.isTochkaSendDisabled = true;
      this.isSendTochkaError = false;

      axios.get(`/payout_create?country_id=ru`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isSendTochkaError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isTochkaSendDisabled = false;
          });
    },

    sendSparkasse() {

      this.message = '';
      this.isSparkasseSendDisabled = true;
      this.isSendSparkasseError = false;

      axios.get(`/payout_create?country_id=de`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isSendSparkasseError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isSparkasseSendDisabled = false;
          });
    },

    sendRevolutPoland() {

      this.message = '';
      this.isRevolutPolandSendDisabled = true;
      this.isSendRevolutPolandError = false;

      axios.get(`/payout_create?country_id=de`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isSendRevolutPolandError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isRevolutPolandSendDisabled = false;
          });
    },


    loadPaymentsRu() {

      this.message = '';
      this.isLoadPaymentsRuDisabled = true;
      this.isLoadPaymentsRuError = false;

      axios.get(`/payment_load?country_id=ru`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isLoadPaymentsRuError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isLoadPaymentsRuDisabled = false;
          });
    },

    loadPaymentsDe() {

      this.message = '';
      this.isLoadPaymentsDeDisabled = true;
      this.isLoadPaymentsDeError = false;

      axios.get(`/payment_load?country_id=de`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isLoadPaymentsDeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isLoadPaymentsDeDisabled = false;
          });
    },

    PayoutStatusUpdateRu() {

      this.message = '';
      this.isPayoutStatusUpdateRuDisabled = true;
      this.isPayoutStatusUpdateRuError = false;

      axios.get(`/payout_status_update?country_id=ru`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isPayoutStatusUpdateRuError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isPayoutStatusUpdateRuDisabled = false;
          });
    },

    PayoutStatusUpdateDe() {

      this.message = '';
      this.isPayoutStatusUpdateDeDisabled = true;
      this.isPayoutStatusUpdateDeError = false;

      axios.get(`/payout_status_update?country_id=de`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isPayoutStatusUpdateDeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isPayoutStatusUpdateDeDisabled = false;
          });
    },

    InvoicesCreateTasksRu() {

      this.message = '';
      this.isInvoicesCreateTasksRuDisabled = true;
      this.isInvoicesCreateTasksRuError = false;

      axios.get(`/create_docs_in_ww_tasks?country_id=ru`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesCreateTasksRuError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesCreateTasksRuDisabled = false;
          });
    },

    InvoicesCreateTasksDe() {

      this.message = '';
      this.isInvoicesCreateTasksDeDisabled = true;
      this.isInvoicesCreateTasksDeError = false;

      axios.get(`/create_docs_in_ww_tasks?country_id=de`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesCreateTasksDeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesCreateTasksDeDisabled = false;
          });
    },

    InvoicesMassCreateRu() {

      this.message = '';
      this.isInvoicesMassCreateRuDisabled = true;
      this.isInvoicesMassCreateRuError = false;

      axios.get(`/mass_create?country_id=Russia`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassCreateRuError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassCreateRuDisabled = false;
          });
    },

    InvoicesMassCreateDe() {

      this.message = '';
      this.isInvoicesMassCreateDeDisabled = true;
      this.isInvoicesMassCreateDeError = false;

      axios.get(`/mass_create?country_id=Germany`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassCreateDeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassCreateDeDisabled = false;
          });
    },

    InvoicesMassCreateAt() {

      this.message = '';
      this.isInvoicesMassCreateAtDisabled = true;
      this.isInvoicesMassCreateAtError = false;

      axios.get(`/mass_create?country_id=Austria`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassCreateAtError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassCreateAtDisabled = false;
          });
    },

    InvoicesMassCreatePl() {

      this.message = '';
      this.isInvoicesMassCreatePlDisabled = true;
      this.isInvoicesMassCreatePlError = false;

      axios.get(`/mass_create?country_id=Poland`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassCreatePlError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassCreatePlDisabled = false;
          });
    },

    InvoicesMassSendDe() {

      this.message = '';
      this.isInvoicesMassSendDeDisabled = true;
      this.isInvoicesMassSendDeError = false;

      axios.get(`/mass_send?country_id=Germany`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassSendDeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassSendDeDisabled = false;
          });
    },

    InvoicesMassSendAt() {

      this.message = '';
      this.isInvoicesMassSendAtDisabled = true;
      this.isInvoicesMassSendAtError = false;

      axios.get(`/mass_send?country_id=Austria`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassSendAtError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassSendAtDisabled = false;
          });
    },

    InvoicesMassSendPl() {

      this.message = '';
      this.isInvoicesMassSendPlDisabled = true;
      this.isInvoicesMassSendPlError = false;

      axios.get(`/mass_send?country_id=Poland`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isInvoicesMassSendPlError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesMassSendPlDisabled = false;
          });
    },

    CallTranscribe() {

      this.message = '';
      this.isInvoicesCallTranscribeDisabled = true;
      this.isCallTranscribeError = false;

      axios.get(`/call_transcribe`)
          .then((res) => {
            console.log(res.data);
          })
          .catch((error) => {
            console.log(error);
            this.isCallTranscribeError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isInvoicesCallTranscribeDisabled = false;
          });
    },

  },

  created() {
    document.title = 'Баланс';

    const userId = localStorage.getItem('userId');
    if (userId && (userId == "10")) {
      this.isSendEnabled = true;
    }

    this.getBalance();
  },

});
